import * as React from "react";
//import styles from './CreateExam.css';
import { v4 } from "uuid";

import { withStyles, WithStyles, createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';

import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
//import '../../resources/img/bg1.jpg';
import { ThemeProvider } from '@material-ui/core/styles';

import { createMuiTheme } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';
import TextField from '@material-ui/core/TextField';

import ExamServer, { Execution } from '../server/ExamServer'
import SchoolIcon from '@material-ui/icons/School';
import AlarmIcon from '@material-ui/icons/Alarm';
import SpellcheckIcon from '@material-ui/icons/Spellcheck';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import Chip from '@material-ui/core/Chip';
import Divider from '@material-ui/core/Divider';
import Fab from '@material-ui/core/Fab';
import CheckIcon from '@material-ui/icons/Check';
import Link from '@material-ui/core/Link';


const theme = createMuiTheme({
    // palette: {
    //     primary: {
    //         main: '#44423e'
    //     },
    //     secondary: {
    //         main: '#FDC400',
    //         contrastText: '#fff'
    //     }
    // }

});


const styles = ((theme: Theme) => createStyles({
    root: {
        padding: theme.spacing(2)
    }
}))



export interface CreateExamProps extends WithStyles<typeof styles> {
    onCreated:(exec:Execution) => void
}

export interface CreateExamState {
    nameText: string,
    loading: boolean,
    checkPolicy: boolean,
}


class CreateExam extends React.Component<CreateExamProps, CreateExamState> {
    
    server: ExamServer;

    constructor(props: CreateExamProps) {
        super(props);
        this.state = {
            nameText: "",
            loading: false,
            checkPolicy:false
        };
        this.server = new ExamServer()

    }

    CreateExamCodeTextChanged = (event: React.ChangeEvent<HTMLInputElement>) => {

        this.setState({ nameText: event.target.value });
    }
    CreateExamCodeTextKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter" && this.state.checkPolicy&& this.state.nameText !=="") {
            this.create()
        }
    }

    handlePolicyCheck = (event:React.ChangeEvent, checked:boolean) => {
        this.setState({checkPolicy:checked})
    }

    create = () => {
        
        this.setState({ loading: true });

        this.server.startExam(this.state.nameText).then(exec => {

            if(exec.id){
                this.props.onCreated && this.props.onCreated(exec)
            }
            this.setState({
                loading: false
            })


        })


    }


    render() {

        const { classes } = this.props;

        return (
            <React.Fragment>

                <Typography variant="h5" color="textPrimary" component="h5" align="center" gutterBottom>
                    Start your Placement Test
                </Typography>



                <Grid container  spacing={2}>
                    <Grid item xs={12}>
                        <Grid container justify="center">
                            <Grid key={0} item spacing={2}>
                                <div style={{padding:theme.spacing(3)}}>
                                    <Typography variant="subtitle1" color="primary" component="p" align="center">
                                        <AlarmIcon  style={{ fontSize: 60 }} /> 
                                    </Typography>
                                    <Typography variant="subtitle1" color="primary" component="p" gutterBottom align="center">
                                        35 Minutes
                                    </Typography>
                        
                                </div>
                            </Grid>

                            <Grid key={1} item spacing={2}>
                                <div style={{padding:theme.spacing(3)}}>
                                    <Typography variant="subtitle1" color="primary" component="p" align="center">
                                        <SchoolIcon  style={{ fontSize: 60 }} /> 
                                    </Typography>
                                    <Typography variant="subtitle1" color="primary" component="p" gutterBottom align="center">
                                        A1 - C2
                                    </Typography>
                        
                                </div>
                            </Grid>

                            <Grid key={2} item spacing={2}>
                                <div style={{padding:theme.spacing(3)}}>
                                    <Typography variant="subtitle1" color="primary" component="p" align="center">
                                        <SpellcheckIcon  style={{ fontSize: 60 }} /> 
                                    </Typography>
                                    <Typography variant="subtitle1" color="primary" component="p" gutterBottom align="center">
                                        120 Questions
                                    </Typography>
                        
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Typography variant="body1" color="textPrimary" component="p" gutterBottom>
                Dieser Test soll Ihre Englischkenntnisse bewerten.
                Er deckt die Niveaus A1 - C2 ab, beginnend mit den leichtesten bis hin zu den schwierigsten.
                Sie haben 35 Minuten Zeit, um den Test zu absolvieren.
                Wenn der Test zu schwierig wird, sollten Sie aufhören!

                </Typography>




                {/* <Typography variant="subtitle1" color="textSecondary" component="p" style={{marginTop:theme.spacing(5)}}>
                    Please enter your Name
                </Typography> */}


                <FormControlLabel
                    style={{padding:theme.spacing(3)}}
                    control={
                    <Checkbox
                        checked={this.state.checkPolicy}
                        value="checked"
                        onChange={this.handlePolicyCheck}
                        color="primary"
                    />
                    }
                    label={<Typography variant="body1" color="textPrimary" component="p" gutterBottom>
                Hiermit bestätige ich, dass ich die <Link onClick={()=>{}} style={{cursor:"pointer"}}>
                Datenschutzrichtlinie
                        </Link> gelesen habe und anerkenne.
                </Typography>}
                />

                <TextField
                    label="Vor- und Nachname"
                    fullWidth
                    margin="normal"
                    value={this.state.nameText}
                    onChange={this.CreateExamCodeTextChanged}
                    onKeyPress={this.CreateExamCodeTextKeyPress}
                    variant="outlined"
                    style={{marginTop:theme.spacing(2)}}
                />

                <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    onClick={this.create}
                    disabled={this.state.loading || this.state.nameText.length < 1 || !this.state.checkPolicy}
                >
                    Start Placement Test
                </Button>

            </React.Fragment>


        )
    }
}

export default withStyles(styles)(CreateExam);
